export const TEST_OPTIONS = [
	{
		value: 'variant_quiz',
		label: 'Quiz',
	},
	{
		value: 'variant_sp',
		label: 'SP',
	},
];
